// extracted by css-extract-rspack-plugin
export default {"suggestedPromptsContainer":"suggestedPromptsContainer-t_9fF4","suggestedPromptsIntro":"suggestedPromptsIntro-T7BZEv","suggestedPromptsButtons":"suggestedPromptsButtons-N6vG07"};